module.exports = __webpack_public_path__ + "img/PL08940.32f25401.png";